class LightboxGallery {
    constructor(gallery) {
        this.attachEvents(gallery, this);
    }

    attachEvents(gallery, self) {
        // Show modal
        const imageButtons = gallery.querySelectorAll("button.lightbox-gallery__item--image");
        if (imageButtons) {
            imageButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    self.openModal(gallery, button.dataset.number);
                });
            });
        }

        // Close modal
        const closeButton = gallery.querySelector("button.lightbox-gallery__modal-close");
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                self.closeModal(gallery);
            });
        }

        // Next image
        const nextButton = gallery.querySelector("button.lightbox-gallery__modal-nav-button--next");
        if (nextButton) {
            nextButton.addEventListener('click', () => {
                let activeNumber = self.getActiveImageNumber(gallery);
                self.setActiveImage(gallery, (++activeNumber));
            });
        }

        // Previous image
        const prevImage = gallery.querySelector("button.lightbox-gallery__modal-nav-button--prev");
        if (prevImage) {
            prevImage.addEventListener('click', () => {
                let activeNumber = self.getActiveImageNumber(gallery);
                self.setActiveImage(gallery, (--activeNumber));
            });
        }

        // Gallery extender
        const galleryExtender = gallery.querySelector("button.lightbox-gallery__item--gallery");
        if (galleryExtender) {
            galleryExtender.addEventListener('click', () => {
                self.openModal(gallery, galleryExtender.dataset.number);
            });
        }
    }

    getActiveImageNumber(gallery) {
        return parseInt(gallery.querySelector('.lightbox-gallery__modal-image-container--active').dataset.number);
    }

    setActiveImage(gallery, number) {
        // If there's a negative number we can presume that the user wants to go from the first image to the last
        if (number < 0) {
            let numberOfTotalImages = parseInt(gallery.querySelector('.lightbox-gallery__modal').dataset.total);
            this.setActiveImage(gallery, (--numberOfTotalImages));
            return;
        }

        // If we don't find an element with the specific number we can presume that the user wants to go from the last image to the next, therefore, we show the first image
        const modalImageToBeSetAsActive = gallery.querySelector(`.lightbox-gallery__modal-image-container[data-number="${number}"]`);
        if (!modalImageToBeSetAsActive) {
            this.setActiveImage(gallery, 0);
            return;
        }

        const currentModalImage = gallery.querySelector('.lightbox-gallery__modal-image-container--active');
        currentModalImage.classList.remove('lightbox-gallery__modal-image-container--active');
        modalImageToBeSetAsActive.classList.add('lightbox-gallery__modal-image-container--active');
    }

    openModal(gallery, number) {
        const modal = gallery.querySelector('.lightbox-gallery__modal');
        const modalImage = gallery.querySelector(`.lightbox-gallery__modal-image-container[data-number="${number}"]`);

        modal.classList.add('lightbox-gallery__modal--visible');
        modalImage.classList.add('lightbox-gallery__modal-image-container--active');
    }

    closeModal(gallery) {
        const modal = gallery.querySelector('.lightbox-gallery__modal');
        const modalImage = gallery.querySelector('.lightbox-gallery__modal-image-container--active');

        modal.classList.remove('lightbox-gallery__modal--visible');
        modalImage.classList.remove('lightbox-gallery__modal-image-container--active');
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const gallery = document.querySelector('.lightbox-gallery');

    if (gallery) {
        new LightboxGallery(gallery);
    }
});